export default __webpack_public_path__ + "static/shoptet-diagram-bright-24c1fe875e3ac8ae14120223de533d4e.png";